// extracted by mini-css-extract-plugin
export default {"default":"DescriptionItem-module__default--HJ0Qf","compact":"DescriptionItem-module__compact--_BAuz"};